
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>
    <Header />
    <Scroll />
    <div class="mall_mypageWrap">
      <div class="mall_widthWrap">
        <div class="mall_pageTopTit">회원가입</div>
        <table class="mallMy_userInfoTable" cellpadding="0" cellspacing="0" summary="회원가입">
          <caption>회원가입</caption>
          <colgroup>
            <col width="20%">
            <col width="*">
          </colgroup>
          <tbody>
            <tr v-if = "formData.customer_ID === ''">
              <th>
                <label for = 'customer_login_ID'>아이디 <span class="pointTextRed">*</span></label>
              </th>
              <td>
                <input
                  type = "text"
                  id = 'customer_login_ID'
                  v-model="formData.customerLoginID"
                  maxlength="15"
                >
                <p class="mallMy_userIT_subTxt">{{errorData.customerLoginIDError}}</p>
              </td>
            </tr>
            <tr v-if = "formData.customer_ID === ''">
              <th>
                <label for = 'customer_password'>비밀번호 <span class="pointTextRed">*</span></label>
              </th>
              <td>
                <input
                  type = "password"
                  id = 'customer_password'
                  v-model="formData.customerPassword"
                  maxlength="20"
                >
                <p class="mallMy_userIT_subTxt">{{errorData.customerPasswordError}}</p>
              </td>
            </tr>
            <tr v-if = "formData.customer_ID === ''">
              <th>
                <label for = 'customer_password_check'>비밀번호 확인 <span class="pointTextRed">*</span></label>
              </th>
              <td>
                <input
                  type = "password"
                  id = 'customer_password_check'
                  v-model="formData.customerPasswordCheck"
                  maxlength="20"
                >
                <p class="mallMy_userIT_subTxt">{{errorData.customerPasswordCheckError}}</p>
              </td>
            </tr>
            <tr>
              <th>
                <label for = 'customer_name'>이름 <span class="pointTextRed">*</span></label>
              </th>
              <td>
                <input
                  type = "text"
                  id = 'customer_name'
                  v-model="formData.customerName"
                  maxlength="10"
                >
                <p class="mallMy_userIT_subTxt">{{errorData.customerNameError}}</p>
              </td>
            </tr>
            <tr>
              <th>
                <label for = 'customer_phone_number'>휴대전화 <span class="pointTextRed">*</span></label>
              </th>
              <td>
                <input
                  type = "text"
                  id = 'customer_phone_number'
                  v-model="formData.customerPhoneNumber"
                  maxlength="20"
                >
                <p class="mallMy_userIT_subTxt">{{errorData.customerPhoneNumberError}}</p>
              </td>
            </tr>
            <tr>
              <th>
                <label for = 'customer_email'>이메일 <span class="pointTextRed">*</span></label>
              </th>
              <td>
                <input
                  type = "text"
                  id = 'customer_email'
                  v-model="formData.customerEmail"
                  maxlength="50"
                >
                <p class="mallMy_userIT_subTxt">{{errorData.customerEmailError}}</p>
              </td>
            </tr>
            <tr>
              <th>
                <label for = 'customer_gender'>성별</label>
              </th>
              <td>
                <select
                  type = "text"
                  id = 'customer_gender'
                  v-model="formData.customerGender"
                >
                  <option value = '1'>남</option>
                  <option value = '2'>여</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>
                <label for = 'customer_zip_code'>주소 <span class="pointTextRed">*</span></label>
              </th>
              <td>
                <div class="mallMy_mIT_address">
                  <div class="mallMy_mIT_addressZipcode">
                    <input
                      type = "text"
                      id = 'customer_zip_code'
                      v-model="formData.customerZipCode"
                      v-on:click="search_address"
                      maxlength="10"
                      readonly
                    >
                    <button
                      v-on:click="search_address"
                    >
                      주소검색
                    </button>
                  </div>
                  <input
                    type = "text"
                    id = 'customer_road_address'
                    v-model="formData.customerRoadAddress"
                    maxlength="150"
                    readonly
                    v-on:click="search_address"
                  >
                  <input
                    type = "text"
                    id = 'customer_detail_address'
                    v-model="formData.customerDetailAddress"
                    maxlength="150"
                    placeholder="상세주소를 입력해주세요."
                  >
                </div>
              </td>
            </tr>
            <tr>
              <th>
              </th>
              <td>
                <div class="mallMy_mIT_checkBox">
                  <input
                    type="checkbox"
                    id="agree_all"
                    v-model="formData.agreeAll"
                    @change="toggleAllAgreements"
                  >
                  <label for="agree_all" style="letter-spacing:-0.6px;">이용약관 및 개인정보수집 및 이용, 쇼핑정보 수신(선택)에 모두 동의합니다.</label>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="mallMy_mIT_checkBox">
                  <input
                    type = "checkbox"
                    id = 'customer_privacy_status'
                    v-model="formData.customerPrivacyStatus"
                  >
                  <label for = 'customer_privacy_status'>(필수) 개인 정보 동의</label>
                  <div v-html="statusData.section3" class="mallMy_uIT_termBox"></div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="mallMy_mIT_checkBox">
                  <input
                    type = "checkbox"
                    id = 'customer_service_agreement_status'
                    v-model="formData.customerServiceAgreementStatus"
                  >
                  <label for = 'customer_service_agreement_status'>(필수) 서비스 이용 동의</label>
                  <div v-html="statusData.section2" class="mallMy_uIT_termBox"></div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="mallMy_mIT_checkBox">
                  <input
                    type = "checkbox"
                    id = 'customer_marketing_status'
                    v-model="formData.customerMarketingStatus"
                  >
                  <label for = 'customer_marketing_status'>(선택) 마케팅 동의</label>
                  <div v-html="statusData.section4" class="mallMy_uIT_termBox"></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="mallMy_uIT_btns">
          <button v-on:click="check_form">
            가입하기
          </button>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
/* eslint-disable camelcase */
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Spiner from '../Section/Spiner.vue'
import Scroll from '../Section/Scroll.vue'
import { ref } from 'vue'
import {
  removeWhitespace,
  validateEngNum,
  validatePassword,
  validateKorEng,
  removeWhitespacePhone,
  validatePhone,
  validateEmail
} from '../../ETC/Validation.vue'
import {
  check_customer_login_ID,
  insert_customer,
  update_customer_easy_join
} from '../../ETC/Axios.vue'
import {
  section2, section4, section3
} from '../TermsAndPolicies/TermsAndPolicies.vue'

export default {
  name: 'Join',
  components: {
    Header: Header,
    Footer: Footer,
    Spiner: Spiner,
    Scroll
  },
  setup () {
    return {
      formData: ref({
        customer_ID: '',
        customerLoginID: '',
        customerPassword: '',
        customerPasswordCheck: '',
        customerName: '',
        customerPhoneNumber: '',
        customerEmail: '',
        customerGender: '1',
        customerZipCode: '',
        customerRoadAddress: '',
        customerDetailAddress: '',
        customerBigArea: '',
        customerSmallArea: '',
        agreeAll: false,
        customerPrivacyStatus: false,
        customerServiceAgreementStatus: false,
        customerMarketingStatus: false
      }),
      errorData: ref({
        customerLoginIDError: '아이디는 필수 입력입니다.',
        customerPasswordError: '비밀번호는 필수 입력입니다.',
        customerPasswordCheckError: '비밀번호 확인은 필수 입력입니다.',
        customerNameError: '이름은 필수 입력입니다.',
        customerPhoneNumberError: '휴대전화는 필수 입력입니다.',
        customerEmailError: '이메일은 필수 입력입니다',
        customerAddressError: '주소는 필수 입력입니다.'
      }),
      statusData: ref({
        customerLoginStatus: false,
        customerPasswordStatus: false,
        customerPasswordCheckStatus: false,
        customerNameStatus: false,
        customerPhoneNumberStatus: false,
        customerEmailStatus: false,
        customerAddressStatus: false,
        spinnerStatus: false,
        section2: section2(),
        section3: section3(),
        section4: section4()
      })
    }
  },
  methods: {
    toggleAllAgreements () {
      const agreeAll = this.formData.agreeAll
      this.formData.customerPrivacyStatus = agreeAll
      this.formData.customerServiceAgreementStatus = agreeAll
      this.formData.customerMarketingStatus = agreeAll
    },
    search_address: function () {
      new window.daum.Postcode({
        oncomplete: (data) => {
          this.formData.customerZipCode = data.zonecode
          this.formData.customerRoadAddress = data.roadAddress === '' ? data.autoRoadAddress : data.roadAddress
          this.formData.customerDetailAddress = data.buildingName
          this.formData.customerBigArea = data.sido
          this.formData.customerSmallArea = data.sigungu
          this.errorData.customerAddressError = ''
          this.statusData.customerAddressStatus = true
        }
      }).open()
    },
    check_form: function () {
      if (this.formData.customerPrivacyStatus === false) {
        alert('개인정보동의를 체크해야 합니다.')
      } else if (this.formData.customerServiceAgreementStatus === false) {
        alert('서비스 이용동의를 체크해야 합니다.')
      } else if (
        this.statusData.customerLoginStatus &&
        this.statusData.customerPasswordStatus &&
        this.statusData.customerPasswordCheckStatus &&
        this.statusData.customerNameStatus &&
        this.statusData.customerPhoneNumberStatus &&
        this.statusData.customerEmailStatus &&
        this.statusData.customerAddressStatus
      ) {
        this.statusData.spinnerStatus = true
        if (this.formData.customer_ID === '') {
          insert_customer(
            this.formData.customerLoginID,
            this.formData.customerPassword,
            this.formData.customerName,
            this.formData.customerPhoneNumber,
            this.formData.customerEmail,
            this.formData.customerGender,
            this.formData.customerZipCode,
            this.formData.customerRoadAddress,
            this.formData.customerDetailAddress,
            this.formData.customerBigArea,
            this.formData.customerSmallArea,
            this.formData.customerPrivacyStatus,
            this.formData.customerServiceAgreementStatus,
            this.formData.customerMarketingStatus
          ).then(result => {
            if (result.success === true) {
              alert('등록이 완료되었습니다. 로그인해주세요.')
              window.location.href = '/Login'
            } else {
              this.statusData.spinnerStatus = false
              alert('등록 중 에러가 발생되었습니다. 관리자한테 문의해주세요.')
            }
          })
        } else {
          update_customer_easy_join(
            this.formData.customer_ID,
            this.formData.customerName,
            this.formData.customerPhoneNumber,
            this.formData.customerEmail,
            this.formData.customerZipCode,
            this.formData.customerRoadAddress,
            this.formData.customerDetailAddress,
            this.formData.customerBigArea,
            this.formData.customerSmallArea,
            this.formData.customerPrivacyStatus,
            this.formData.customerServiceAgreementStatus,
            this.formData.customerMarketingStatus
          ).then(result => {
            this.statusData.spinnerStatus = false
            alert('등록 및 로그인이 완료되었습니다.')
            this.$router.push('/')
          })
        }
      } else {
        alert('입력사항을 확인하셔야 합니다.')
      }
    }
  },
  watch: {
    'formData.customerPrivacyStatus': function () {
      this.formData.agreeAll =
        this.formData.customerPrivacyStatus &&
        this.formData.customerServiceAgreementStatus &&
        this.formData.customerMarketingStatus
    },
    'formData.customerServiceAgreementStatus': function () {
      this.formData.agreeAll =
        this.formData.customerPrivacyStatus &&
        this.formData.customerServiceAgreementStatus &&
        this.formData.customerMarketingStatus
    },
    'formData.customerMarketingStatus': function () {
      this.formData.agreeAll =
        this.formData.customerPrivacyStatus &&
        this.formData.customerServiceAgreementStatus &&
        this.formData.customerMarketingStatus
    },
    'formData.customerLoginID': function (value) {
      this.formData.customerLoginID = removeWhitespace(value)
      check_customer_login_ID(removeWhitespace(value)).then(result => {
        if (result === 0) {
          if (removeWhitespace(value) === '') {
            this.errorData.customerLoginIDError = '아이디는 필수로 입력해야 합니다.'
            this.statusData.customerLoginStatus = false
          } else if (removeWhitespace(value).length < 5) {
            this.errorData.customerLoginIDError = '아이디는 최소 6자이상 입력해야 합니다.'
            this.statusData.customerLoginStatus = false
          } else if (validateEngNum(removeWhitespace(value))) {
            this.errorData.customerLoginIDError = ''
            this.statusData.customerLoginStatus = true
          } else {
            this.errorData.customerLoginIDError = '한글 및 특수문자는 입력할 수 없습니다.'
            this.statusData.customerLoginStatus = false
          }
        } else {
          this.errorData.customerLoginIDError = '중복된 아이디가 있습니다.'
          this.statusData.customerLoginStatus = false
        }
      })
    },
    'formData.customerPassword': function (value) {
      this.formData.customerPassword = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.customerPasswordError = '비밀번호는 필수로 입력해야 합니다.'
        this.statusData.customerPasswordStatus = false
      } else if (validatePassword(removeWhitespace(value))) {
        this.errorData.customerPasswordError = ''
        this.statusData.customerPasswordStatus = true
      } else {
        this.errorData.customerPasswordError = '최소 8자리 / 숫자, 특수문자 각 1회 이상을 입력해야 합니다.'
        this.statusData.customerPasswordStatus = false
      }
    },
    'formData.customerPasswordCheck': function (value) {
      this.formData.customerPasswordCheck = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.customerPasswordCheckError = '비밀번호 확인은 필수로 입력해야 합니다.'
        this.statusData.customerPasswordCheckStatus = false
      } else if (this.formData.customerPassword === value) {
        this.errorData.customerPasswordCheckError = ''
        this.statusData.customerPasswordCheckStatus = true
      } else {
        this.errorData.customerPasswordCheckError = '비밀번호가 일치하지 않습니다.'
        this.statusData.customerPasswordCheckStatus = false
      }
    },
    'formData.customerName': function (value) {
      this.formData.customerName = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.customerNameError = '이름은 필수로 입력해야 합니다.'
        this.statusData.customerNameStatus = false
      } else if (removeWhitespace(value).length < 2) {
        this.errorData.customerNameError = '이름은 최소 2자이상 입력해야 합니다.'
        this.statusData.customerNameStatus = false
      } else if (validateKorEng(removeWhitespace(value))) {
        this.errorData.customerNameError = ''
        this.statusData.customerNameStatus = true
      } else {
        this.errorData.customerNameError = '한글 및 영문만 입력해야 합니다.'
        this.statusData.customerNameStatus = false
      }
    },
    'formData.customerPhoneNumber': function (value) {
      this.formData.customerPhoneNumber = removeWhitespacePhone(value)
      if (removeWhitespacePhone(value) === '') {
        this.errorData.customerPhoneNumberError = '휴대전화는 필수로 입력해야 합니다.'
        this.statusData.customerPhoneNumberStatus = false
      } else if (validatePhone(removeWhitespacePhone(value))) {
        this.errorData.customerPhoneNumberError = ''
        this.statusData.customerPhoneNumberStatus = true
      } else {
        this.errorData.customerPhoneNumberError = '휴대전화 형식으로 입력해야 합니다.'
        this.statusData.customerPhoneNumberStatus = false
      }
    },
    'formData.customerEmail': function (value) {
      this.formData.customerEmail = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.customerPhoneNumberError = '이메일은 필수로 입력해야 합니다.'
        this.statusData.customerPhoneNumberStatus = false
      } else if (validateEmail(removeWhitespace(value))) {
        this.errorData.customerEmailError = ''
        this.statusData.customerEmailStatus = true
      } else {
        this.errorData.customerEmailError = '이메일 형식으로 입력해야 합니다.'
        this.statusData.customerEmailStatus = false
      }
    }
  },
  mounted () {
    if (this.$route.query.customer_ID) {
      this.formData.customer_ID = this.$route.query.customer_ID
      this.formData.customerEmail = this.$route.query.customer_email
      this.formData.customerName = this.$route.query.customer_name
      this.statusData.customerLoginStatus = true
      this.statusData.customerPasswordStatus = true
      this.statusData.customerPasswordCheckStatus = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Join/Join.vue